(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7756],{

/***/ 6573:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mint/claimer",
      function () {
        return __webpack_require__(73875);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mint_claimer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/common/PageHead.tsx
var PageHead = __webpack_require__(47270);
// EXTERNAL MODULE: ./src/airdrop/components/Container.tsx
var Container = __webpack_require__(54167);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/icons.tsx
var icons = __webpack_require__(58163);
// EXTERNAL MODULE: ./src/components/common/ShareLinkModal.tsx
var ShareLinkModal = __webpack_require__(90600);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/components/mint/ConnectWalletStep.tsx
var ConnectWalletStep = __webpack_require__(49328);
// EXTERNAL MODULE: ./src/components/mint/VerifyAccountsStep.tsx + 3 modules
var VerifyAccountsStep = __webpack_require__(18359);
// EXTERNAL MODULE: ./src/components/mint/SelectValidatorStep.tsx
var SelectValidatorStep = __webpack_require__(56674);
// EXTERNAL MODULE: ./src/components/mint/ClaimerMintResult.tsx
var ClaimerMintResult = __webpack_require__(45206);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./src/hooks/useVerifyClaim.ts
var useVerifyClaim = __webpack_require__(37091);
// EXTERNAL MODULE: ./node_modules/lottie-web/build/player/lottie.js
var lottie = __webpack_require__(11248);
var lottie_default = /*#__PURE__*/__webpack_require__.n(lottie);
// EXTERNAL MODULE: ./src/lottie/giftBox.json
var giftBox = __webpack_require__(24881);
// EXTERNAL MODULE: ./src/hooks/useMintClaimer.tsx
var useMintClaimer = __webpack_require__(55541);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./src/stores/index.ts + 23 modules
var stores = __webpack_require__(27234);
// EXTERNAL MODULE: ./node_modules/@leenguyen/react-flip-clock-countdown/dist/index.modern.js
var index_modern = __webpack_require__(38472);
// EXTERNAL MODULE: ./node_modules/@leenguyen/react-flip-clock-countdown/dist/index.css
var dist = __webpack_require__(26837);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(94491);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/hooks/useRequest.tsx
var useRequest = __webpack_require__(21706);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
;// CONCATENATED MODULE: ./src/hooks/payment/useDepositInfo.tsx



function useDepositInfo(payment) {
    var address = (0,useAccount/* default */.Z)().address;
    var ref = (0,useRequest/* default */.Z)(payment && payment.enableOneClick && address ? {
        function: "network/getDepositAmount",
        data: {
            token: {
                address: payment.tokenAddress,
                chainId: payment.chain.id,
                decimals: payment.chain.nativeCurrency.decimals,
                name: payment.chain.nativeCurrency.name
            },
            mintType: "claimer",
            userAddress: address
        },
        header: {
            endpoint: "network"
        }
    } : null, (0,_object_spread/* default */.Z)({}, useRequest/* disableRevalidate */.U)), escrowDeposit = ref.data, isLoading = ref.isLoading;
    return {
        amount: (escrowDeposit === null || escrowDeposit === void 0 ? void 0 : escrowDeposit.tokenAmount) || 0,
        contractAddress: escrowDeposit === null || escrowDeposit === void 0 ? void 0 : escrowDeposit.escrowContractAddress,
        isLoading: isLoading,
        info: escrowDeposit
    };
}

// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var wagmi_dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__(8891);
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
;// CONCATENATED MODULE: ./src/components/payment/CryptocurrencyPaymentDialog.tsx

















var PaymentIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "#585858"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M11.4995 14.3627H5.49945C5.38243 14.3627 5.26747 14.3319 5.16613 14.2733C5.06479 14.2148 4.98063 14.1307 4.92212 14.0293L1.92212 8.83333C1.86374 8.73194 1.83301 8.61699 1.83301 8.5C1.83301 8.383 1.86374 8.26805 1.92212 8.16666L4.92212 2.97066C4.98063 2.86932 5.06479 2.78516 5.16613 2.72665C5.26747 2.66814 5.38243 2.63733 5.49945 2.63733H11.4995C11.6165 2.63733 11.7314 2.66814 11.8328 2.72665C11.9341 2.78516 12.0183 2.86932 12.0768 2.97066L15.0768 8.16666C15.1352 8.26805 15.1659 8.383 15.1659 8.5C15.1659 8.61699 15.1352 8.73194 15.0768 8.83333L12.0768 14.0293C12.0183 14.1307 11.9341 14.2148 11.8328 14.2733C11.7314 14.3319 11.6165 14.3627 11.4995 14.3627Z"
        })
    }));
};
var CryptocurrencyPaymentDialog = function(param) {
    var title = param.title, opened = param.opened, onClose = param.onClose, payments = param.payments, payBtnText = param.payBtnText, onMint = param.onMint;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var address = (0,useAccount/* default */.Z)().address;
    var ref18 = (0,react.useState)(-1), selectPaymentIndex = ref18[0], setSelectPaymentIndex = ref18[1];
    var payment = payments[selectPaymentIndex];
    var ref19 = (0,react.useState)(false), minting = ref19[0], setMinting = ref19[1];
    var bridgeInfo = useDepositInfo(payment);
    var ref20 = (0,useVerifyClaim/* default */.Z)("karat"), changeForm = ref20.changeForm, changeVerifyState = ref20.changeVerifyState;
    var ref21 = (0,wagmi_dist/* useBalance */.KQ)({
        address: address,
        chainId: payment === null || payment === void 0 ? void 0 : (ref = payment.chain) === null || ref === void 0 ? void 0 : ref.id,
        enabled: !!payment
    }), balance = ref21.data;
    var ref22 = (0,wagmi_dist/* useBalance */.KQ)(!!(payment === null || payment === void 0 ? void 0 : (ref1 = payment.mintFee) === null || ref1 === void 0 ? void 0 : ref1.token) && (payment === null || payment === void 0 ? void 0 : (ref2 = payment.mintFee) === null || ref2 === void 0 ? void 0 : ref2.token.address) != payment.tokenAddress ? {
        address: address,
        token: payment === null || payment === void 0 ? void 0 : (ref3 = payment.mintFee) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.token) === null || ref4 === void 0 ? void 0 : ref4.address,
        chainId: payment === null || payment === void 0 ? void 0 : (ref5 = payment.mintFee) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.token) === null || ref6 === void 0 ? void 0 : ref6.chainId
    } : undefined), tokenBalance = ref22.data, error = ref22.error;
    var onChoosePayment = (0,react.useCallback)(function(index) {
        setSelectPaymentIndex(index);
        var payment = payments[index];
        if (payment) {
            mixpanel_cjs_default().track("choose_crypto_payment", {
                type: payment.name
            });
        }
    }, [
        payments,
        setSelectPaymentIndex
    ]);
    var splitMintFee = !(payment === null || payment === void 0 ? void 0 : payment.enableOneClick) && !!(payment === null || payment === void 0 ? void 0 : payment.mintFee) && (payment === null || payment === void 0 ? void 0 : (ref7 = payment.mintFee) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.token) === null || ref8 === void 0 ? void 0 : ref8.address) !== (payment === null || payment === void 0 ? void 0 : payment.tokenAddress);
    var gasFee = new bignumber/* default */.Z((payment === null || payment === void 0 ? void 0 : payment.gas) || 0);
    var bridgeFee = new bignumber/* default */.Z((bridgeInfo === null || bridgeInfo === void 0 ? void 0 : (ref9 = bridgeInfo.info) === null || ref9 === void 0 ? void 0 : ref9.tokenEscrowAmount) || 0);
    var mintFee = new bignumber/* default */.Z((payment === null || payment === void 0 ? void 0 : (ref10 = payment.mintFee) === null || ref10 === void 0 ? void 0 : ref10.tokenAmount) || 0);
    if (payment === null || payment === void 0 ? void 0 : payment.enableOneClick) {
        var ref23;
        mintFee = new bignumber/* default */.Z((bridgeInfo === null || bridgeInfo === void 0 ? void 0 : (ref23 = bridgeInfo.info) === null || ref23 === void 0 ? void 0 : ref23.tokenMintAmount) || 0);
    }
    var totalNativeFee = gasFee.plus(bridgeFee).plus(!splitMintFee ? mintFee : 0);
    var isMintFeeInsufficient = new bignumber/* default */.Z((payment === null || payment === void 0 ? void 0 : (ref11 = payment.mintFee) === null || ref11 === void 0 ? void 0 : ref11.token) && (payment === null || payment === void 0 ? void 0 : (ref12 = payment.mintFee) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.token) === null || ref13 === void 0 ? void 0 : ref13.address) !== payment.tokenAddress ? (tokenBalance === null || tokenBalance === void 0 ? void 0 : tokenBalance.formatted) || 0 : (balance === null || balance === void 0 ? void 0 : balance.formatted) || 0).isLessThan(mintFee);
    var isInsufficient = isMintFeeInsufficient || totalNativeFee.isGreaterThan(new bignumber/* default */.Z((balance === null || balance === void 0 ? void 0 : balance.formatted) || 0));
    var onMintClick = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var payment;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payment = payments[selectPaymentIndex];
                    if (minting || !payment) {
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    setMinting(true);
                    return [
                        4,
                        onMint(payment)
                    ];
                case 2:
                    _state.sent();
                    onClose();
                    return [
                        3,
                        4
                    ];
                case 3:
                    setMinting(false);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        minting,
        onMint,
        payments,
        selectPaymentIndex,
        onClose
    ]);
    (0,react.useEffect)(function() {
        if (bridgeInfo.info) {
            changeForm(bridgeInfo.info);
        } else {
            changeForm(null);
        }
        changeVerifyState(true);
    }, [
        bridgeInfo.info
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        opened: opened,
        onClose: onClose,
        withCloseButton: false,
        centered: true,
        size: 495,
        radius: 16,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-2 top-2 p-3 cursor-pointer z-10",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCloseCircle */.SV5, {
                    className: "fill-primary",
                    size: 26
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative p-5 font-exo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center text-[32px] text-correct font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-sm",
                                children: "How do you want to pay for transaction fees?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-2 gap-2 mt-4",
                                children: payments.map(function(payment, index) {
                                    var ref, ref1;
                                    var isActive = selectPaymentIndex === index;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center justify-center border border-[#E0E1E1] p-4 rounded-[4px] min-h-[100px] cursor-pointer ".concat(isActive ? isInsufficient ? "bg-[#F9F9F9]" : "bg-primary text-white" : "", " "),
                                        onClick: function() {
                                            onChoosePayment(index);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentIcon, {
                                                        className: isActive ? isInsufficient ? "" : "fill-white" : ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm ml-1 font-semibold",
                                                        children: payment.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-1",
                                                children: payment.enableOneClick ? payment.symbol : (ref = payment.mintFee) === null || ref === void 0 ? void 0 : (ref1 = ref.token) === null || ref1 === void 0 ? void 0 : ref1.symbol
                                            }),
                                            isActive && isInsufficient && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-xs mt-2",
                                                children: "Insufficient balance"
                                            })
                                        ]
                                    }, payment === null || payment === void 0 ? void 0 : payment.name);
                                })
                            })
                        ]
                    }),
                    payment ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-4 py-4 px-6 bg-[#F9F9F9] rounded-lg flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark2",
                                        children: "Mint fee"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            (0,format/* amountDesc */.sB)(mintFee.toNumber(), 4),
                                            " ",
                                            (payment === null || payment === void 0 ? void 0 : (ref14 = payment.mintFee) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.token) === null || ref15 === void 0 ? void 0 : ref15.symbol) || payment.symbol,
                                            " ($5)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-dark2",
                                        children: [
                                            "Gas on ",
                                            payment.chain.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-xs mr-1",
                                                children: "Est."
                                            }),
                                            payment.gas,
                                            " ",
                                            payment.symbol
                                        ]
                                    })
                                ]
                            }),
                            payment.enableOneClick && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark2",
                                        children: "Karat bridging fee"
                                    }),
                                    bridgeInfo.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative h-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LoadingIcon */.Ho, {
                                            className: "w-4 h-4 absolute top-[1px] right-0"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: bridgeFee.isEqualTo(0) ? "--" : "".concat(bridgeFee.toFixed(4), " ").concat(payment.symbol, " ($2)")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between font-semibold mt-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark1 ",
                                        children: "Transaction summary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: totalNativeFee.isGreaterThan(0) ? "".concat(totalNativeFee.toFixed(4), " ").concat(payment.symbol, " ").concat(splitMintFee ? "+ ".concat((0,format/* amountDesc */.sB)(mintFee.toNumber(), 4), " ").concat((payment === null || payment === void 0 ? void 0 : (ref16 = payment.mintFee) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.token) === null || ref17 === void 0 ? void 0 : ref17.symbol) || payment.symbol) : "") : "--"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-4 py-4 px-6 bg-[#F9F9F9] rounded-lg flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark2",
                                        children: "Gas"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "--"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between font-semibold",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-dark1 ",
                                        children: "Transaction summary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "--"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 flex flex-col justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: "w-[149px]",
                                size: "md",
                                radius: "xl",
                                disabled: !payment || bridgeInfo.isLoading || isInsufficient,
                                onClick: onMintClick,
                                loading: minting,
                                children: payBtnText || "Pay & mint"
                            }),
                            payment && payment.nativeBridgeUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: payment.nativeBridgeUrl,
                                target: "_blank",
                                rel: "noreferrer",
                                className: "mt-4 text-primary text-sm font-semibold action hover:text-primary",
                                children: [
                                    "Use ",
                                    payment.name,
                                    " Native Bridge"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var payment_CryptocurrencyPaymentDialog = (CryptocurrencyPaymentDialog);

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(91759);
// EXTERNAL MODULE: ./src/services/payment.ts
var services_payment = __webpack_require__(78338);
// EXTERNAL MODULE: ./src/config/config.js
var config = __webpack_require__(35055);
;// CONCATENATED MODULE: ./src/components/mint/claimer/Zksync.tsx























var payments = [
    // cryptoPayments.zkSyncKAT,
    services_payment/* cryptoPayments.polygon */.J.polygon,
    services_payment/* cryptoPayments.bsc */.J.bsc,
    services_payment/* cryptoPayments.ethereum */.J.ethereum,
    services_payment/* cryptoPayments.zkSync */.J.zkSync, 
];
if (false) {}
var ZksyncClaimer = function() {
    var ref = (0,react.useState)(false), claimed = ref[0], setClaimed = ref[1];
    var ref1 = (0,react.useState)(false), giftBoxShow = ref1[0], setGiftBoxShow = ref1[1];
    var ref2 = (0,useVerifyClaim/* default */.Z)(), verified = ref2.verified, form = ref2.form, result = ref2.result;
    var ref3 = (0,useMintClaimer/* default */.Z)(), contractMintWithPay = ref3.contractMintWithPay, contractMint = ref3.contractMint, claimerContractInfo = ref3.claimerContractInfo, karatMint = ref3.karatMint, minting = ref3.minting, nftMeta = ref3.nftMeta, isValidLieutenant = ref3.isValidLieutenant, hasParamLieutenant = ref3.hasParamLieutenant;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), mintDialogOpened = ref4[0], ref5 = ref4[1], openMintDialog = ref5.open, closeMintDialog = ref5.close;
    var claimerContract = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.devtool.config.claimerContract;
    });
    (0,react.useEffect)(function() {
        if (claimerContractInfo.minted && !minting) {
            setClaimed(true);
        }
    }, [
        claimerContractInfo.minted,
        minting
    ]);
    var onMintSuccess = (0,react.useCallback)(function() {
        setGiftBoxShow(true);
        var animation = lottie_default().loadAnimation({
            container: document.getElementById("gift-box"),
            renderer: "svg",
            loop: false,
            autoplay: true,
            animationData: giftBox
        });
        animation.addEventListener("complete", function() {
            setGiftBoxShow(false);
            animation.destroy();
            setClaimed(true);
        });
    }, []);
    var onKaratMint = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        karatMint()
                    ];
                case 1:
                    res = _state.sent();
                    if (!res) {
                        return [
                            2
                        ];
                    }
                    onMintSuccess();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    react_toastify_esm/* toast.error */.Am.error(e.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        karatMint
    ]);
    var onContractMint = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type, amount) {
            var res, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            contractMint()
                        ];
                    case 1:
                        res = _state.sent();
                        if (!res) {
                            return [
                                2
                            ];
                        }
                        onMintSuccess();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        react_toastify_esm/* toast.error */.Am.error(e.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(type, amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        contractMint
    ]);
    var launchDate = new Date("2023-08-25T04:44:44.746Z");
    var less24Hours = launchDate.getTime() - Date.now() < 24 * 1000 * 60 * 60;
    var reachLaunchDate = new Date() >= launchDate;
    var canMint = !claimerContractInfo.minted && ( false || reachLaunchDate) && (!hasParamLieutenant || isValidLieutenant);
    if (claimed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimerMintResult/* default */.Z, {
            nftMeta: nftMeta,
            chainId: config/* zksyncChainId */.LK
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full  h-full top-0 left-0 flex items-center justify-center ".concat(giftBoxShow ? "z-[999] bg-[rgba(0,0,0,0.6)]" : "-z-10"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "gift-box",
                    className: "relative w-[500px] h-[500px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-[#f9f9f9] py-4 px-8 rounded-xl mb-7 flex gap-10 flex-wrap text-dark2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-semibold mb-1",
                                        children: "Quantity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            claimerContractInfo.quantity.toString(),
                                            " Minted"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-semibold mb-1",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Free"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "font-semibold mb-1 flex items-center",
                                        children: [
                                            "Contract address",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/mint/secure3.png",
                                                className: "h-[22px] ml-1"
                                            })
                                        ]
                                    }),
                                    claimerContract ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-primary action hover:text-primary",
                                        href: "https://explorer.zksync.io/address/".concat(claimerContract),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: (0,format/* trimAddr1 */.Cr)(claimerContract, 8)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Coming soon"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gap-4 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletStep/* default */.Z, {
                                chainId: config/* zksyncChainId */.LK
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyAccountsStep/* default */.Z, {
                                chainId: config/* zksyncChainId */.LK
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectValidatorStep/* default */.Z, {
                                chainId: config/* zksyncChainId */.LK
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center mt-10",
                        children: [
                            hasParamLieutenant && !isValidLieutenant && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-10 text-error text-sm max-w-[468px] text-center",
                                children: "The referral link has an incorrect Lieutenant address. Please contact the referrer or remove the address from the URL."
                            }),
                            !reachLaunchDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
                                    renderMap: [
                                        !less24Hours,
                                        true,
                                        true,
                                        true
                                    ],
                                    to: launchDate.getTime(),
                                    digitBlockStyle: {
                                        background: "#ffffff",
                                        color: "#2d2d2d",
                                        height: "24px",
                                        width: "22px",
                                        fontSize: "16px",
                                        fontWeight: 900
                                    },
                                    labelStyle: {
                                        fontSize: 12,
                                        color: "dark"
                                    },
                                    separatorStyle: {
                                        size: 0
                                    },
                                    dividerStyle: {
                                        height: "0px"
                                    }
                                })
                            }),
                            config/* isMaintenance */.b6 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                classNames: {
                                    inner: "text-body w-[130px]",
                                    root: "w-[185px]"
                                },
                                size: "md",
                                radius: "xl",
                                disabled: true,
                                children: "Under maintenance"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                classNames: {
                                    inner: "text-body w-[100px]",
                                    root: "w-[155px]"
                                },
                                size: "md",
                                radius: "xl",
                                disabled: !verified || !claimerContract || !canMint,
                                onClick: openMintDialog,
                                children: "Mint"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_CryptocurrencyPaymentDialog, {
                title: "Mint Claimer",
                serviceId: "mint/claimer",
                opened: mintDialogOpened,
                onClose: closeMintDialog,
                payments: payments,
                onMint: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(payment) {
                        var ref, ref1, ref2, ref3;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!!payment.enableOneClick) return [
                                        3,
                                        5
                                    ];
                                    if (!(((ref = payment.mintFee) === null || ref === void 0 ? void 0 : (ref1 = ref.token) === null || ref1 === void 0 ? void 0 : ref1.address) === "0xCDb7D260c107499C80B4b748e8331c64595972a1")) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        onContractMint(services_payment/* ClaimerPaymentType.KAT */.z.KAT, ((ref2 = payment.mintFee) === null || ref2 === void 0 ? void 0 : ref2.tokenAmount) || 0)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 2:
                                    return [
                                        4,
                                        onContractMint(services_payment/* ClaimerPaymentType.ETH */.z.ETH, ((ref3 = payment.mintFee) === null || ref3 === void 0 ? void 0 : ref3.tokenAmount) || 0)
                                    ];
                                case 3:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 4:
                                    return [
                                        3,
                                        7
                                    ];
                                case 5:
                                    return [
                                        4,
                                        onKaratMint()
                                    ];
                                case 6:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(payment) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        ]
    });
};
/* harmony default export */ var Zksync = (ZksyncClaimer);

// EXTERNAL MODULE: ./src/chain-info/KaratDaoSupportedChain.ts
var KaratDaoSupportedChain = __webpack_require__(93171);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 71 modules
var chunk_LAFZBYO7 = __webpack_require__(17276);
// EXTERNAL MODULE: ./src/services/network/claimer.ts
var claimer = __webpack_require__(21373);
// EXTERNAL MODULE: ./src/hooks/useClaimerContract.ts
var useClaimerContract = __webpack_require__(48728);
// EXTERNAL MODULE: ./src/hooks/useMintReferral.ts
var useMintReferral = __webpack_require__(65581);
// EXTERNAL MODULE: ./src/utils/validate.ts
var validate = __webpack_require__(68974);
// EXTERNAL MODULE: ./src/services/contract.ts + 10 modules
var services_contract = __webpack_require__(26720);
;// CONCATENATED MODULE: ./src/hooks/useMintChainClaimer.tsx
















function parseFormValidatorId(form) {
    var validatorId = !form.validator ? "13" : form.validator === "empty" ? "13" : form.validator;
    return validatorId;
}
function useMintChainClaimer(chainId) {
    var ref = (0,useAccount/* default */.Z)(), address = ref.address, isLogin = ref.isLogin, login = ref.login;
    var chain = (0,wagmi_dist/* useNetwork */.LN)().chain;
    var contract = services_contract/* claimerContracts */.rR[chainId];
    var ref1 = (0,react.useState)(false), minting = ref1[0], setMinting = ref1[1];
    var switchNetworkAsync = (0,wagmi_dist/* useSwitchNetwork */.g0)().switchNetworkAsync;
    var form = (0,useVerifyClaim/* default */.Z)().form;
    var ref2 = (0,useMintReferral/* default */.Z)(chainId), lieutenantAddress = ref2.lieutenantAddress, isValidLieutenant = ref2.isValidLieutenant, hasParamLieutenant = ref2.hasParamLieutenant;
    var ref3 = (0,react.useState)(null), nftMeta = ref3[0], setNftMeta = ref3[1];
    var claimerContractInfo = (0,useClaimerContract/* default */.Z)(chainId);
    // @ts-ignore
    var ref4 = (0,wagmi_dist/* useContractWrite */.GG)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract), {
        functionName: "mintClaimerwithSig"
    })), mintClaimerByContract = ref4.writeAsync;
    var contractMint = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var validatorId, result, res, transReceipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setMinting(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        11,
                        12
                    ]);
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== chainId)) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        switchNetworkAsync(chainId)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    console.log("form", form);
                    validatorId = parseFormValidatorId(form);
                    console.log("validatorId", validatorId);
                    return [
                        4,
                        (0,claimer/* requestMintClaimerSignature */.qE)({
                            walletAddress: address,
                            validatorTokenId: validatorId,
                            lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000"
                        })
                    ];
                case 4:
                    result = _state.sent();
                    setNftMeta((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result.message), {
                        validator: validatorId
                    }));
                    return [
                        4,
                        mintClaimerByContract({
                            args: [
                                address,
                                parseInt(validatorId || "0"),
                                parseInt(result.message.score),
                                lieutenantAddress || "0x0000000000000000000000000000000000000000",
                                parseInt(result.message.role),
                                result.signedMessage
                            ]
                        })
                    ];
                case 5:
                    res = _state.sent();
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        10
                    ]);
                    return [
                        4,
                        (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)(res)
                    ];
                case 7:
                    transReceipt = _state.sent();
                    if (transReceipt.status === "reverted") {
                        throw new Error("Mint fail");
                    }
                    return [
                        3,
                        10
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        4,
                        (0,validate/* isSkipError */.D0)(e)
                    ];
                case 9:
                    if (!_state.sent()) {
                        throw e;
                    }
                    return [
                        3,
                        10
                    ];
                case 10:
                    mixpanel_cjs_default().track("claimer_minted", {
                        walletAddress: address,
                        validatorTokenId: validatorId,
                        lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000",
                        mintType: "contract"
                    });
                    stores/* default.dispatch */.ZP.dispatch(stores/* actions.mint.setHistory */.Nw.mint.setHistory({
                        history: null,
                        type: "claimer"
                    }));
                    return [
                        2,
                        true
                    ];
                case 11:
                    setMinting(false);
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }), [
        mintClaimerByContract,
        switchNetworkAsync,
        chain,
        address,
        chainId,
        isLogin,
        login,
        form,
        lieutenantAddress, 
    ]);
    return {
        minting: minting,
        claimerContractInfo: claimerContractInfo,
        defaultDepositCost: 0.02,
        nftMeta: nftMeta,
        isValidLieutenant: isValidLieutenant,
        hasParamLieutenant: hasParamLieutenant,
        contractMint: contractMint
    };
}

;// CONCATENATED MODULE: ./src/components/mint/claimer/CustomChain.tsx




















var CustomChain = function(param) {
    var chainId = param.chainId;
    var ref = (0,react.useState)(false), giftBoxShow = ref[0], setGiftBoxShow = ref[1];
    var ref1 = (0,useVerifyClaim/* default */.Z)(), verified = ref1.verified, form = ref1.form, result = ref1.result;
    var ref2 = (0,react.useState)(false), claimed = ref2[0], setClaimed = ref2[1];
    var ref3 = useMintChainClaimer(chainId), contractMint = ref3.contractMint, claimerContractInfo = ref3.claimerContractInfo, minting = ref3.minting, nftMeta = ref3.nftMeta, isValidLieutenant = ref3.isValidLieutenant, hasParamLieutenant = ref3.hasParamLieutenant;
    var mintChain = KaratDaoSupportedChain/* KARATDAO_DEFAULT_SUPPORTED_CHAINS.find */.f.find(function(item) {
        return item.chainId === chainId;
    });
    var claimerContract = services_contract/* claimerContracts */.rR[chainId];
    (0,react.useEffect)(function() {
        if (claimerContractInfo.minted && !minting) {
            setClaimed(true);
        }
    }, [
        claimerContractInfo.minted,
        minting
    ]);
    var onMintSuccess = (0,react.useCallback)(function() {
        setGiftBoxShow(true);
        var animation = lottie_default().loadAnimation({
            container: document.getElementById("gift-box-claimer"),
            renderer: "svg",
            loop: false,
            autoplay: true,
            animationData: giftBox
        });
        animation.addEventListener("complete", function() {
            setGiftBoxShow(false);
            animation.destroy();
            setClaimed(true);
        });
    }, []);
    var onContractMint = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var res, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        contractMint()
                    ];
                case 1:
                    res = _state.sent();
                    if (!res) {
                        return [
                            2
                        ];
                    }
                    onMintSuccess();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    react_toastify_esm/* toast.error */.Am.error(e.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        contractMint,
        onMintSuccess
    ]);
    console.log("verified", verified, form, result);
    var launchDate = new Date("2023-08-25T04:44:44.746Z");
    var less24Hours = launchDate.getTime() - Date.now() < 24 * 1000 * 60 * 60;
    var reachLaunchDate = new Date() >= launchDate;
    var canMint = !claimerContractInfo.minted && ( false || reachLaunchDate) && (!hasParamLieutenant || isValidLieutenant);
    if (claimed) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimerMintResult/* default */.Z, {
            nftMeta: nftMeta,
            chainId: chainId
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full  h-full top-0 left-0 flex items-center justify-center ".concat(giftBoxShow ? "z-[999] bg-[rgba(0,0,0,0.6)]" : "-z-10"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "gift-box-claimer",
                    className: "relative w-[500px] h-[500px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-[#f9f9f9] py-4 px-8 rounded-xl mb-7 flex gap-10 flex-wrap text-dark2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-semibold mb-1",
                                        children: "Quantity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            claimerContractInfo.quantity.toString(),
                                            " Minted"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "font-semibold mb-1",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Free"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "font-semibold mb-1 flex items-center",
                                        children: [
                                            "Contract address",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/mint/secure3.png",
                                                className: "h-[22px] ml-1"
                                            })
                                        ]
                                    }),
                                    claimerContract ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-primary action hover:text-primary",
                                        href: mintChain.getExplorerAddressLink(claimerContract.address),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: (0,format/* trimAddr1 */.Cr)(claimerContract.address, 8)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Coming soon"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "gap-4 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletStep/* default */.Z, {
                                chainId: chainId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyAccountsStep/* default */.Z, {
                                chainId: chainId
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectValidatorStep/* default */.Z, {
                                chainId: chainId
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center mt-10",
                        children: [
                            hasParamLieutenant && !isValidLieutenant && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-10 text-error text-sm max-w-[468px] text-center",
                                children: "The referral link has an incorrect Lieutenant address. Please contact the referrer or remove the address from the URL."
                            }),
                            !reachLaunchDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.Z, {
                                    renderMap: [
                                        !less24Hours,
                                        true,
                                        true,
                                        true
                                    ],
                                    to: launchDate.getTime(),
                                    digitBlockStyle: {
                                        background: "#ffffff",
                                        color: "#2d2d2d",
                                        height: "24px",
                                        width: "22px",
                                        fontSize: "16px",
                                        fontWeight: 900
                                    },
                                    labelStyle: {
                                        fontSize: 12,
                                        color: "dark"
                                    },
                                    separatorStyle: {
                                        size: 0
                                    },
                                    dividerStyle: {
                                        height: "0px"
                                    }
                                })
                            }),
                            config/* isMaintenance */.b6 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                classNames: {
                                    inner: "text-body w-[130px]",
                                    root: "w-[185px]"
                                },
                                size: "md",
                                radius: "xl",
                                disabled: true,
                                children: "Under maintenance"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                classNames: {
                                    inner: "text-body w-[100px]",
                                    root: "w-[155px]"
                                },
                                size: "md",
                                radius: "xl",
                                disabled: !verified || !claimerContract || !canMint,
                                loading: minting,
                                onClick: onContractMint,
                                children: "Mint"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var claimer_CustomChain = (CustomChain);

// EXTERNAL MODULE: ./src/chain-info/ZetaChain.ts
var ZetaChain = __webpack_require__(98982);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Tabs/Tabs.js + 11 modules
var Tabs = __webpack_require__(21141);
;// CONCATENATED MODULE: ./src/pages/mint/claimer/index.tsx












var ClaimerMint = function() {
    var ref = (0,react.useState)(false), shareLinkOpened = ref[0], setShareLinkOpened = ref[1];
    var ref1 = (0,react.useState)(""), shareLink = ref1[0], setShareLink = ref1[1];
    var activeChain = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.account.dataChainId;
    });
    var setActiveChain = (0,react.useCallback)(function(chainId) {
        stores/* default.dispatch */.ZP.dispatch(stores/* actions.account.setDataChainId */.Nw.account.setDataChainId(parseInt(chainId)));
    }, []);
    (0,react.useEffect)(function() {
        setShareLink(window.location.href);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "layout-block px-5 py-10 pb-[115px] sm:px-[140px] sm:py-[115px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "max-w-[447px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[28px] leading-tight font-bold text-dark1",
                                        children: "Claim your Karat ID"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2 font-medium text-dark2",
                                        children: "Karat ID is a key part of Karat's Multichain Socialfi Dapps and Karat’s AA wallet. Karat ID will be the foundation of an aggregated multi-chain name service."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[44px] sm:w-[149px] h-[44px] flex items-center justify-center border border-primary text-primary font-semibold rounded-full action",
                                        onClick: function() {
                                            setShareLinkOpened(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ShareIcon */.aA, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-1 hidden sm:block",
                                                children: "Share"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-[250px] right-0 sm:left-0 top-[54px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLinkModal/* default */.Z, {
                                            opened: shareLinkOpened,
                                            setOpened: setShareLinkOpened,
                                            link: shareLink
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col flex-col-reverse sm:flex-row mt-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:mr-14 flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                                    value: String(activeChain),
                                    onTabChange: setActiveChain,
                                    classNames: {
                                        tabsList: "mb-7"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs.List */.m.List, {
                                            grow: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                                    value: String(ZetaChain/* ZetaChain_Test.chainId */.O.chainId),
                                                    children: "ZETA network"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                                    value: String(config/* zksyncChainId */.LK),
                                                    children: "zkSync ETH network"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                                            value: String(config/* zksyncChainId */.LK),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Zksync, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                                            value: String(ZetaChain/* ZetaChain_Test.chainId */.O.chainId),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(claimer_CustomChain, {
                                                chainId: ZetaChain/* ZetaChain_Test.chainId */.O.chainId
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full mb-8 sm:mb-0 sm:w-[341px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/mint/claimer-mint-gift.png",
                                    className: "w-full"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mint_claimer = (ClaimerMint);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,3454,2280,6034,7258,4304,6518,7435,9632,6832,1141,7172,2256,7356,2227,2889,6243,5316,1099,9774,2888,179], function() { return __webpack_exec__(6573); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);